<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <h1>Scheduling Dashboard</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="well">
          <form class="form-inline" @submit.prevent="applyFilters">
            <div class="form-group" style="margin-right: 10px">
              <label for="sd-start-date">Start Date</label>
              <input
                type="date"
                id="sd-start-date"
                class="form-control"
                v-model="localFilters.start_date"
              />
            </div>
            <div class="form-group" style="margin-right: 10px">
              <label for="sd-end-date">End Date</label>
              <input
                type="date"
                id="sd-end-date"
                class="form-control"
                v-model="localFilters.end_date"
              />
            </div>
            <div class="form-group" style="margin-right: 10px">
              <label for="sd-granularity">Granularity</label>
              <select
                id="sd-granularity"
                class="form-control"
                v-model="localFilters.granularity"
              >
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
              </select>
            </div>
            <div class="form-group" style="margin-right: 10px">
              <label for="sd-yoy">YoY Type</label>
              <select
                id="sd-yoy"
                class="form-control"
                v-model="localFilters.yoy_type"
              >
                <option value="same_period">Same Period</option>
                <option value="rolling">Rolling</option>
              </select>
            </div>
            <div class="checkbox" style="margin-right: 10px">
              <label>
                <input
                  type="checkbox"
                  v-model="localFilters.include_instructor_breakdown"
                />
                Include Instructor Breakdown
              </label>
            </div>
            <div class="checkbox" style="margin-right: 10px">
              <label>
                <input
                  type="checkbox"
                  v-model="localFilters.include_location_breakdown"
                />
                Include Location Breakdown
              </label>
            </div>
            <button type="submit" class="btn btn-dc">Apply</button>
          </form>
        </div>
      </div>
    </div>

    <div v-if="error" class="row">
      <div class="col-xs-12">
        <div class="alert alert-danger">{{ error }}</div>
      </div>
    </div>

    <div v-if="loading" class="row">
      <div class="col-xs-12 text-center">
        <i class="fa fa-circle-o-notch fa-spin fa-2x"></i>
      </div>
    </div>

    <div v-if="dashboardData && !loading">
      <SummaryCards :summary="dashboardData.summary" />

      <YoYComparison
        v-if="dashboardData.yoy_comparison"
        :summary="dashboardData.summary"
        :yoy-comparison="dashboardData.yoy_comparison"
      />

      <div class="row">
        <div class="col-xs-12">
          <TimeSeriesChart :time-series="dashboardData.time_series" />
        </div>
      </div>

      <BookingPatternsChart
        v-if="dashboardData.booking_patterns"
        :booking-patterns="dashboardData.booking_patterns"
      />

      <div class="row">
        <div class="col-md-4">
          <SessionTypesChart
            v-if="dashboardData.session_types"
            :session-types="dashboardData.session_types"
          />
        </div>
        <div class="col-md-8">
          <InstructorBreakdownTable
            v-if="dashboardData.instructor_breakdown"
            :instructor-breakdown="dashboardData.instructor_breakdown"
          />
        </div>
      </div>

      <div class="row" v-if="dashboardData.location_breakdown">
        <div class="col-xs-12">
          <DrivesHeatMap
            :location-breakdown="dashboardData.location_breakdown"
            :zip-boundaries="zipBoundaries"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SummaryCards from "./components/SummaryCards.vue";
import YoYComparison from "./components/YoYComparison.vue";
import TimeSeriesChart from "./components/TimeSeriesChart.vue";
import BookingPatternsChart from "./components/BookingPatternsChart.vue";
import SessionTypesChart from "./components/SessionTypesChart.vue";
import InstructorBreakdownTable from "./components/InstructorBreakdownTable.vue";
import DrivesHeatMap from "./components/DrivesHeatMap.vue";

export default {
  name: "SchedulingDashboard",
  components: {
    SummaryCards,
    YoYComparison,
    TimeSeriesChart,
    BookingPatternsChart,
    SessionTypesChart,
    InstructorBreakdownTable,
    DrivesHeatMap,
  },
  props: {
    dashboardData: { type: Object, default: null },
    zipBoundaries: {
      type: Array,
      default: function () {
        return [];
      },
    },
    loading: { type: Boolean, default: false },
    error: { type: String, default: "" },
    filters: { type: Object, required: true },
    onFilterChange: { type: Function, required: true },
  },
  data: function () {
    return {
      localFilters: Object.assign({}, this.filters),
    };
  },
  watch: {
    filters: {
      handler: function (newVal) {
        this.localFilters = Object.assign({}, newVal);
      },
      deep: true,
    },
  },
  methods: {
    applyFilters: function () {
      this.onFilterChange(Object.assign({}, this.localFilters));
    },
  },
};
</script>
